import React from 'react'
import { ReactComponent as CheckCircleSvg } from 'assets/icons/check-circle.svg'
import { ReactComponent as CheckSvg } from 'assets/icons/check.svg'
import { ReactComponent as TravelExploreSvg } from 'assets/icons/travel_explore.svg'
import { ReactComponent as SendSvg } from 'assets/icons/send.svg'
import { ReactComponent as VerifiedSvg } from 'assets/icons/verified.svg'
import { ReactComponent as VerifiedUserSvg } from 'assets/icons/verified_user.svg'
import { ReactComponent as PeopleSvg } from 'assets/icons/people.svg'
import { ReactComponent as ClockSvg } from 'assets/icons/clock.svg'
import { ReactComponent as AssignmentSvg } from 'assets/icons/assignment.svg'
import { ReactComponent as PersonSvg } from 'assets/icons/person.svg'
import { ReactComponent as InfoSvg } from 'assets/icons/info.svg'
import { ReactComponent as WarningSvg } from 'assets/icons/warning.svg'
import { ReactComponent as PsychologySvg } from 'assets/icons/psychology.svg'
import { ReactComponent as ChevronLeftSvg } from 'assets/icons/chevron-left.svg'
import { ReactComponent as ArrowRightSvg } from 'assets/icons/arrow_short_right.svg'
import { ReactComponent as UniversitySvg } from 'assets/icons/university.svg'
import { ReactComponent as EventSvg } from 'assets/icons/event.svg'
import { ReactComponent as ReloadSvg } from 'assets/icons/reload.svg'
import { ReactComponent as FolderSvg } from 'assets/icons/folder.svg'
import { ReactComponent as PlanetSvg } from 'assets/icons/planet.svg'
import { ReactComponent as BagLineSvg } from 'assets/icons/bag-line.svg'
import { ReactComponent as TabletCheckSvg } from 'assets/icons/tablet-check.svg'
import { ReactComponent as PenSvg } from 'assets/icons/pen.svg'
import { ReactComponent as SavedSvg } from 'assets/icons/saved.svg'
import { ReactComponent as ParentsSvg } from 'assets/icons/parents.svg'
import { ReactComponent as ListSvg } from 'assets/icons/list.svg'
import { ReactComponent as CalendarSvg } from 'assets/icons/calendar.svg'
import { ReactComponent as CapSvg } from 'assets/icons/cap.svg'
import { ReactComponent as UploadSvg } from 'assets/icons/upload.svg'
import { ReactComponent as OpenedEyeSvg } from 'assets/icons/openedEye.svg'
import { ReactComponent as DockArticleSvg } from 'assets/icons/dock_article.svg'
import { ReactComponent as BadgeSvg } from 'assets/icons/badge.svg'
import { ReactComponent as BookmarksSvg } from 'assets/icons/bookmarks.svg'
import s from './ReportIcon.module.scss'

/**
 * SVG icon component replacing material-icons-outlined across Reports pages.
 * Accepts material icon name strings (same names used in JSX today) so callers
 * need minimal changes. Missing icons render an empty SVG placeholder with
 * data-missing-icon — no font glyph text is ever rendered.
 */

const ICON_MAP = {
	check_circle: CheckCircleSvg,
	check: CheckSvg,
	travel_explore: TravelExploreSvg,
	send: SendSvg,
	verified: VerifiedSvg,
	verified_user: VerifiedUserSvg,
	group: PeopleSvg,
	groups: PeopleSvg,
	schedule: ClockSvg,
	assignment: AssignmentSvg,
	person: PersonSvg,
	info: InfoSvg,
	warning: WarningSvg,
	psychology: PsychologySvg,
	psychology_alt: PsychologySvg,
	chevron_left: ChevronLeftSvg,
	chevron_right: ChevronLeftSvg,
	arrow_forward: ArrowRightSvg,
	school: CapSvg,
	account_balance: UniversitySvg,
	event_available: EventSvg,
	event: EventSvg,
	calendar_today: CalendarSvg,
	sync: ReloadSvg,
	folder_open: FolderSvg,
	public: PlanetSvg,
	work_outline: BagLineSvg,
	task_alt: TabletCheckSvg,
	task: TabletCheckSvg,
	edit_note: PenSvg,
	bookmark_added: SavedSvg,
	parents: ParentsSvg,
	family_restroom: ParentsSvg,
	list: ListSvg,
	download: UploadSvg,
	// Closest existing assets until dedicated SVGs are provided
	person_search: PersonSvg,
	priority_high: WarningSvg,
	north_east: ArrowRightSvg,
	visibility: OpenedEyeSvg,
	flag_circle: CheckCircleSvg,
	fact_check: TabletCheckSvg,
	explore: TravelExploreSvg,
	recommend: BadgeSvg,
	description: DockArticleSvg,
	format_list_numbered: ListSvg,
	bookmarks: BookmarksSvg,
}

export const ReportIcon = ({ name, className = '', size, 'aria-hidden': ariaHidden = true }) => {
	const isFlipped = name === 'chevron_right'
	const Svg = ICON_MAP[name]
	const sizeClass = size ? s[`report-icon--${size}`] : ''

	if (!Svg) {
		return (
			<svg
				className={`${s['report-icon']} ${s['report-icon--missing']} ${sizeClass} ${className}`.trim()}
				viewBox="0 0 24 24"
				width="1em"
				height="1em"
				aria-hidden={ariaHidden}
				data-missing-icon={name}
			/>
		)
	}

	return (
		<Svg
			className={`${s['report-icon']} ${isFlipped ? s['report-icon--flip'] : ''} ${sizeClass} ${className}`.trim()}
			width="1em"
			height="1em"
			aria-hidden={ariaHidden}
		/>
	)
}

export default ReportIcon
